import React, { useState, useContext } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { FiMenu, FiPhone } from "react-icons/fi";
import { BsQuestionLg } from "react-icons/bs";
import { BiSearch } from "react-icons/bi";
import { TbLogin } from "react-icons/tb";
import { SlBasket } from "react-icons/sl";
import { HiLocationMarker } from "react-icons/hi";
import Row from "react-bootstrap/Row";
import { GoChevronLeft } from "react-icons/go";
import logo from "../../../assets/images/ekia.png";
import SearchDrawer from "../MobileHeader/SearchDrawer";
import LocationDrawer from "../MobileHeader/LocationDrawer";
import MenuDrawer from "./MenuDrawer";
// import "bootstrap/dist/css/bootstrap.min.css";
import Container from "../../LogIn/Container";
import "./mobileHeader.scss";
import ekia from "../../../assets/images/ekia.png";
import WithAuthentication from "context/Authentication/AuthenticationContext.ts";
import CardItemContext from "context/CardItem/CardItemContext";
import Basket from "../Header/Basket";
import { Link } from "react-router-dom";
import useAxios from "services/useAxios.tsx";
import { useRef } from "react";
import { debounce } from "lodash";
import { useEffect } from "react";
import {NavLink} from "react-router-dom";

const MobileHeader = ({ close, closeDrawer }) => {
  const { execute: searchApi } = useAxios("api3/search");

  const auth = useContext(WithAuthentication);
  const { basketData, showOffcanvas, setShowOffcanvas, itemCount } =
    useContext(CardItemContext);
  const [show, setShow] = useState(false);
  const [showlocation, setShowLocation] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loginShow, setLoginShow] = useState(false);
  const { userInfo, isLogged, logout } = useContext(WithAuthentication);

  const [searchQuery, setSearchQuery] = useState("");
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [articles, setArticles] = useState([]);

  const callApiSearch = (query) => {
    let data = {};
    data.title = query;
    data.page = 1;
    data.count = 6;

    // Make your API call using the search query
    searchApi(data).then((res) => {
      setProducts(res.products.slice(0, 10));
      setCategories(res.hashtags.slice(0, 10));
      setArticles(res.post.slice(0, 10));
    });

    // Replace this console.log with your actual API call
  };
  const searchDebounce = useRef(
    debounce((text) => {
      callApiSearch(text);
    }, 2000)
  );
  useEffect(() => {
    callApiSearch("");
  }, []);
  return (
    <div className="mobile_header">
      <div className="mobile_nav">
        <FiMenu
          size={20}
          color="#3f4064"
          className="hamburger_menu"
          onClick={() => setShowMenu(true)}
        />
        <NavLink to="/">
        <img src={ekia} className="mobile_logo" />
        </NavLink>
        <div className="support_online">
          <BsQuestionLg size={17} color="#3f4064" />
        </div>
      </div>
      <div>
        <Offcanvas
          show={showMenu}
          onHide={() => setShowMenu(false)}
          placement="start"
          className="menu_drawer"
        >
          <Offcanvas.Body className="humberger_menu-drawer">
            <MenuDrawer setShowMenu={setShowMenu} />
          </Offcanvas.Body>
        </Offcanvas>
      </div>
      <div className="mobile_search">
        <Row className="align-items-center">
          <div className="col-8 col-sm-9 col-md-9">
            <div className="mobile_search-box" onClick={handleShow}>
              <BiSearch size={17} className="mobile_search-icon" />
              <input
                type="search"
                placeholder="جستجو"
                className="mobile_search-input"
              />
            </div>
            <div>
              <Offcanvas
                show={show}
                placement="bottom"
                onHide={handleClose}
                backdrop="static"
                className="drawer_box"
              >
                <Offcanvas.Body>
                  <SearchDrawer
                    close={handleClose}
                    searchDebounce={searchDebounce}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    products={products}
                    categories={categories}
                    articles={articles}
                  />
                </Offcanvas.Body>
              </Offcanvas>
            </div>
          </div>
          <div className="col-2 col-md-2">
            
          {isLogged == false ?(
            <div className="mobile_login">
              <TbLogin
                size={25}
                color="#3f4064"
                className="mobile_login-icon"
                onClick={() => {
                  setLoginShow(true);
                }}
                />
                <span
                  className="mobile_login-text"
                  onClick={() => {
                    setLoginShow(true);
                  }}
                  >
                  ورود
                </span>
                  </div>
              ):(
          <div
            className="d-flex align-items-center pointer border rounded justify-content-center pd-6 "
            onClick={()=>{document.getElementById("footer-container").scrollIntoView({behavior:"smooth",block:"nearest"})}}>
            <span className="pe-2 font-12-400 text-nowrap d-none d-sm-flex">تماس با ما</span>
            <FiPhone
                className="wh-14 text-opacity-75"
            />
          </div>
)}
</div>
          <div className="col-2 col-sm-1 position-relative col-md-1">
            <div
              className="mobile_buying"
              onClick={(e) => setShowOffcanvas((prev) => !prev)}
            >
              <SlBasket size={25} color="#3f4064" />
            </div>
            {itemCount != 0 && (
              <div
                className="d-flex p-1 align-items-center justify-content-center text-light rounded-pill position-absolute"
                style={{
                  backgroundColor: "tomato",
                  width: 16,
                  height: 16,
                  fontSize: 10,
                  top: -3,
                  right: -5,
                }}
              >
                {itemCount}
              </div>
            )}
          </div>
        </Row>
      </div>
      {/* <div className="mobile_location" onClick={() => setShowLocation(true)}>
        <div className="mobile_location-city">
          <HiLocationMarker size={20} color="#f9a825" />
          <span>ارسال به استان گلستان، گرگان</span>
        </div>
        <div className="mobile_location-chevron">
          <GoChevronLeft size={20} color="#3f4064" />
        </div>
      </div> */}
      <div>
        <Offcanvas
          show={showlocation}
          onHide={() => setShowLocation(false)}
          placement="bottom"
          backdrop="static"
          className="location_drawer"
        >
          <Offcanvas.Body>
            <LocationDrawer closeDrawer={setShowLocation} />
          </Offcanvas.Body>
        </Offcanvas>
      </div>
      <Container loginShow={loginShow} setLoginShow={setLoginShow} />
      <Basket />
    </div>
  );
};

export default MobileHeader;
